import { TJuicedData, TSummarizedContent } from "./types";

const formatSummarizedContentForAI = (content: TSummarizedContent): string => {
  let formatted = content.summary;
  if (Array.isArray(content.keyPoints) && content.keyPoints.length > 0) {
    formatted += "\n\n**Key Points:**\n" + content.keyPoints.map((point) => `- ${point}`).join("\n");
  }
  return formatted;
};

const formatExtractedContentForAI = (content: TJuicedData): string => {
  const header = `### File ${content.fileName}`;
  const descBlock = `Description of the file: ${content.description || "No description available"}`;
  const pageSections = content.pages.map((page, index) => `#### Page ${index + 1}\n\n${page.text || ""}`).join("\n\n");
  return `${header}\n\n${descBlock}\n\n${pageSections}\n\n`;
};

export function getFullContentDisplay(extractedContent: TJuicedData | undefined): string {
  if (!extractedContent) return "No extracted content available";
  if (Array.isArray(extractedContent.pages) && extractedContent.pages.length > 0) {
    return formatExtractedContentForAI(extractedContent);
  }
  if (extractedContent.description) return extractedContent.description;
  return JSON.stringify(extractedContent, null, 2);
}

export function getSummaryContentDisplay(summarizedContent: TSummarizedContent | undefined): string {
  if (!summarizedContent) return "";
  return formatSummarizedContentForAI(summarizedContent);
}

export function getContentDisplay({
  extractedContent,
  summarizedContent
}: {
  extractedContent: TJuicedData | undefined;
  summarizedContent: TSummarizedContent | undefined;
}) {
  const fullContentDisplay = getFullContentDisplay(extractedContent);
  const summaryContentDisplay = getSummaryContentDisplay(summarizedContent);
  return { fullContentDisplay, summaryContentDisplay };
}
